import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PartnerWorkConfigurationService {
  private baseUrl = `${environment.urlConfig.serviceUrl}/partnerworkconfigurations`;

  constructor(private http: HttpClient) { }

  get(partnerId: number): Observable<Boo.Objects.Work.PartnerWorkConfiguration[]> {
    return this.http.get<Boo.Objects.Work.PartnerWorkConfiguration[]>(`${this.baseUrl}/${partnerId}`);
  }

  save(partnerId: number, partnerWorkConfigurations: Boo.Objects.Work.PartnerWorkConfiguration[]): Observable<any> {
    return this.http.post(`${this.baseUrl}`, {
        partnerId: partnerId,
        partnerWorkConfigurations: partnerWorkConfigurations
    });
  }

  getTaskTypes(partnerId: number): Observable<Boo.Objects.Work.SeoMinute.SeoWorkTaskType[]> {
    return this.http.get<Boo.Objects.Work.SeoMinute.SeoWorkTaskType[]>(`${this.baseUrl}/${partnerId}/tasktypes`);
  }

  getProducts(partnerId: number): Observable<Boo.Objects.Work.PartnerProductSummary[]> {
    return this.http.get<Boo.Objects.Work.PartnerProductSummary[]>(`${this.baseUrl}/${partnerId}/products`);
  }

  generatePreview(partnerId: number, hours: number, partnerWorkConfigurations: Boo.Objects.Work.PartnerWorkConfiguration[]): Observable<Boo.Objects.Work.PartnerTaskTypeAllocation[]> {
    return this.http.post<Boo.Objects.Work.PartnerTaskTypeAllocation[]>(`${this.baseUrl}/${partnerId}/generatePreview`, {
        partnerId: partnerId,
        hours: hours,
        partnerWorkConfigurations: partnerWorkConfigurations
    });
  }

  getConfiguredPartners(): Observable<Boo.Objects.PartnerFragment[]> {
    return this.http.get<Boo.Objects.PartnerFragment[]>(`${this.baseUrl}/configuredPartners`);
  }
}
